import React, { useEffect, useState } from 'react';
import CalendarSelector from './CalendarSelector';

const SwitchType = ({ event, socket }) => {
  const [selectedType, setSelectedType] = useState(event.tipus);

  useEffect(() => {
    setSelectedType(event.tipus);
  }, [event.tipus]);

  const changeType = (newType) => {
    setSelectedType(newType);
    socket.emit('.change_event_tipus', event.hash, newType);
  }

  const options = [
    { value: 'assaig', label: 'Assaig' },
    { value: 'actuació', label: 'Actuació' },
    { value: 'activitat', label: 'Activitat' },
  ];

  return (
    <CalendarSelector
      label="Tipus"
      options={options}
      selectedValues={selectedType}
      onSelect={changeType}
    />
  );
};

export default SwitchType;
